var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 50,
    height: 50,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(2 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M2,42.153l5.541-6.459V13.459L2.627,7.847V7H15.7L26.15,29.447,35.35,7H48v.847l-4.182,3.918V38.341L48,42.153V43H29.809v-.847L34.1,37.071V17.165L23.641,43H22.282L10.155,17.694V35.482L15.7,42.153V43H2Z",
    transform: "translate(-2 -7)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumWhite);
export default __webpack_public_path__ + "static/media/Medium-white.65fe5a017cb40851918b53c54061e3d5.svg";
export { ForwardRef as ReactComponent };